import { put, select, takeLatest } from 'redux-saga/effects'
import { StateCustomDataConstants } from '../store/nemsisCustomData.constants'
import { IStateCustomDataDisplayState, IStateCustomElements } from '../store/nemsisCustomData.types'
import { setCustomDisplayData } from '../store/nemsisCustomData.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getStateCustomDisplayDataSelector } from '../selectors/stateCustomDisplayData.selector'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

function updateCustomElements(
  stateCustomElements: IStateCustomElements,
  state: string,
  groupKey: string,
  groupingSequence: number | null,
  key?: string
) {
  return stateCustomElements?.map((stateObj) => {
    if (stateObj.state === state) {
      return {
        ...stateObj,
        groups: stateObj.groups.map((group) => {
          if (group?.groupKey === groupKey && group?.groupingSequence === groupingSequence) {
            return {
              ...group,
              customElements: group?.customElements
                .map((customElement) => {
                  if (
                    customElement?.key === key &&
                    group?.customElements?.filter((a) => a.id === customElement?.id).length === 1
                  ) {
                    const isLastCustomElement =
                      group?.customElements?.length === 1 && group?.customElements[0]?.id === customElement?.id
                    const { results, resultsPNNV, ...rest } = customElement
                    return { ...rest, isDuplicated: isLastCustomElement ? true : false }
                  }

                  if (customElement?.key === key) {
                    return null
                  }

                  return customElement
                })
                .filter(Boolean),
            }
          }
          return group
        }),
      }
    }
    return stateObj
  })
}

export function* deleteCustomElement() {
  try {
    const customDisplayData: IStateCustomDataDisplayState = yield select(getStateCustomDisplayDataSelector)
    const { state, groupKey, groupingSequence, key } = customDisplayData

    const updatedStateCustomElements = updateCustomElements(
      customDisplayData.stateCustomElements,
      state,
      groupKey,
      groupingSequence,
      key
    )
    yield put(setCustomDisplayData(updatedStateCustomElements))
  } catch (error) {
    yield put(throwPcrException(`deleteCustomElementSaga() error: ${error}`))
  }
}

export function* deleteCustomElementSaga() {
  yield takeLatest(StateCustomDataConstants.DELETE_CUSTOM_ELEMENT, performWithMutexHOG, deleteCustomElement)
}
